import React, { FC } from 'react'
import { Button } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { confirmarConta } from '../../core/_requests'
import { ID } from '../../../../../../../_metronic/helpers'
import { FetchState, useModal } from '../../../../../../components'
import { FuncionarioView } from '../../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

interface Props {
  id: ID
}

const ConfirmarContaModal: FC<Props> = ({ id }) => {
  const { fetchStates, closeModal } = useModal()
  const { t } = useT()

  const { data: usuario } = (fetchStates['funcionario'] || {}) as FetchState<FuncionarioView>

  const handleConfirmarConta = async () => {
    try {
      await confirmarConta(usuario?.pessoa?.usuario?.id)
      Swal.fire({
        text: 'Conta confirmada com sucesso!',
        icon: 'success',
        buttonsStyling: false,
        confirmButtonText: 'Ok',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      }).then(() => {
        closeModal()
      })
    } catch (error) {
      Swal.fire({
        text: 'Erro ao confirmar conta',
        icon: 'error',
        buttonsStyling: false,
        confirmButtonText: 'Ok',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    }
  }

  return (
    <div className='d-flex flex-column'>
      <span className='fs-3'>
        Tem certeza de que deseja confirmar a conta de <b>{usuario?.nome}?</b>
      </span>
      <div className='d-flex justify-content-center mt-5'>
        <Button variant='secondary' className='me-3' onClick={closeModal}>
          {t('common.cancel')}
        </Button>
        <Button variant='primary' onClick={() => handleConfirmarConta()}>
          Confirmar
        </Button>
      </div>
    </div>
  )
}

export { ConfirmarContaModal }
